/**
 * @class Request
 */
export default class Request {
    /**
     * @param {Number}          id
     * @param {Number}          tabId
     * @param {String}          method
     * @param {Object | null}   next
     * @param {Boolean}         skip
     */
    constructor(id, tabId, method, next = null, skip = false) {
        this._id = id;
        this._tabId = tabId;
        this._method = method;
        this._next = next;
        this._skip = skip;
        this._time = new Date().getTime();
    }

    /**
     * @return {Number}
     */
    get id() {
        return this._id;
    }

    /**
     * @param {Number} id
     */
    set id(id) {
        this._id = id;
    }

    /**
     * @return {Number}
     */
    get tabId() {
        return this._tabId;
    }

    /**
     * @param {Number} tabId
     */
    set tabId(tabId) {
        this._tabId = tabId;
    }

    /**
     * @return {String}
     */
    get method() {
        return this._method;
    }

    /**
     * @param {String} method
     */
    set method(method) {
        this._method = method;
    }

    /**
     * @return {Object}
     */
    get next() {
        return this._next;
    }

    /**
     * @param {Object} next
     */
    set next(next) {
        this._next = next;
    }

    /**
     * @return {Boolean}
     */
    get skip() {
        return this._skip;
    }

    /**
     * @param {Boolean} skip
     */
    set skip(skip) {
        this._skip = skip;
    }

    /**
     * @return {Number}
     */
    get time() {
        return this._time;
    }

    /**
     * @param {Number} time
     */
    set time(time) {
        this._time = time;
    }

    /**
     * @return {Object}
     */
    clone() {
        let newRequest = new Request(this._id, this._tabId, this._method, this._next, this._skip);
        newRequest.time = this._time;

        return newRequest;
    }

    /**
     * @return {Object}
     */
    skipRequest() {
        let request = this.clone();
        request.skip = true;

        return request;
    }
}
